export default {
  BUSCARPLACAEMAIL (state, info) {
    state.buscarplacaemail = info  
  },
  CADASTRAREMAIL (state, info) {
    state.cadastraremail = info
  },
  ALTERAREMAIL (state, info) {
    state.alteraremail = info
  },
  DELETAREMAIL (state, info) {
    state.deletaremail = info
  },
  BUSCAREMAILS (state, info){
    state.buscaremails = info
  }
}